// extracted by mini-css-extract-plugin
module.exports = {"more":"more__14TL1","blank":"blank__1--nr","colored":"colored__T1Ak9","menu":"menu__3DGJt","button":"button__3w0m8"};